import React from 'react';
// @ts-ignore
import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n/functions';
import { connect } from '../../../base/redux/functions';
import Input from '../../../base/ui/components/web/Input';
import AbstractSharedVideoDialog from '../AbstractSharedVideoDialog';
/**
 * Component that renders the video share dialog.
 *
 * @returns {React$Element<any>}
 */
class SharedVideoDialog extends AbstractSharedVideoDialog {
    /**
     * Instantiates a new component.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            okDisabled: true,
            error: false
        };
        this._onChange = this._onChange.bind(this);
        this._onSubmitValue = this._onSubmitValue.bind(this);
    }
    /**
     * Callback for the onChange event of the field.
     *
     * @param {string} value - The static event.
     * @returns {void}
     */
    _onChange(value) {
        this.setState({
            value,
            okDisabled: !value
        });
    }
    /**
     * Callback to be invoked when the value of the link input is submitted.
     *
     * @returns {boolean}
     */
    _onSubmitValue() {
        const result = super._onSetVideoLink(this.state.value);
        if (!result) {
            this.setState({
                error: true
            });
        }
        return result;
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {
        const { t } = this.props;
        const { error } = this.state;
        return (React.createElement(Dialog, { hideCancelButton: false, okDisabled: this.state.okDisabled, okKey: t('dialog.Share'), onSubmit: this._onSubmitValue, titleKey: t('dialog.shareVideoTitle'), width: 'small' },
            React.createElement(Input, { autoFocus: true, error: error, label: t('dialog.videoLink'), name: 'sharedVideoUrl', onChange: this._onChange, placeholder: t('dialog.sharedVideoLinkPlaceholder'), type: 'text', value: this.state.value }),
            error && React.createElement("span", { className: 'shared-video-dialog-error' }, t('dialog.sharedVideoDialogError'))));
    }
}
export default translate(connect()(SharedVideoDialog));
